import * as React from 'react';

const TypeScriptIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height={28} viewBox="0 0 29 28" width={29} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M27.1587 0H1.7827C1.05811 0 0.470703 0.587403 0.470703 1.312V26.688C0.470703 27.4126
            1.05811 28 1.7827 28H27.1587C27.8833 28 28.4707 27.4126 28.4707 26.688V1.312C28.4707
            0.587403 27.8833 0 27.1587 0Z"
            fill="white"
        />
        <path
            clipRule="evenodd"
            d="M16.7157 21.7591V24.8271C17.2731 25.1022 17.8672 25.2959 18.4797 25.4021C19.1875 25.5328 
            19.9059 25.597 20.6257 25.5941C21.3272 25.5974 22.0271 25.5267 22.7137 25.3831C23.3302 25.2585 
            23.9184 25.0212 24.4487 24.6831C24.941 24.3653 25.3468 23.9303 25.6297 23.4171C26.1363 22.3544 
            26.2031 21.1348 25.8157 20.0231C25.6522 19.6074 25.4086 19.2279 25.0987 18.9061C24.7661 18.564 
            24.3882 18.2689 23.9757 18.0291C23.5007 17.7509 23.0072 17.5057 22.4987 17.2951C22.0987 17.1291 
            21.7387 16.9678 21.4187 16.8111C21.1345 16.675 20.8625 16.5148 20.6057 16.3321C20.4046 16.1911 
            20.2299 16.0158 20.0897 15.8141C19.9685 15.631 19.9055 15.4156 19.9087 15.1961C19.906 14.9941
            19.9623 14.7956 20.0707 14.6251C20.1884 14.4466 20.3454 14.2975 20.5297 14.1891C20.755 14.0565
            21.0001 13.9609 21.2557 13.9061C21.5695 13.8364 21.8902 13.8028 22.2117 13.8061C22.482 13.807 
            22.752 13.8264 23.0197 13.8641C23.3088 13.9032 23.5948 13.9623 23.8757 14.0411C24.1614 14.1203 
            24.4408 14.2206 24.7117 14.3411C24.9745 14.4583 25.2259 14.5995 25.4627 14.7631V11.9001C24.9698 
            11.7136 24.4587 11.5795 23.9377 11.5001C23.3086 11.4086 22.6734 11.3654 22.0377 11.3711C21.3428 
            11.3674 20.6499 11.4462 19.9737 11.6061C19.3624 11.7458 18.7812 11.994 18.2577 12.3391C17.7714 
            12.6631 17.3698 13.0989 17.0867 13.6101C16.7867 14.1778 16.6382 14.8133 16.6557 15.4551C16.6335 
            16.3039 16.9131 17.133 17.4447 17.7951C18.0969 18.5292 18.9193 19.092 19.8397 19.4341C20.2597 
            19.6074 20.6514 19.7771 21.0147 19.9431C21.3425 20.089 21.6576 20.2619 21.9567 20.4601C22.1979 
            20.617 22.4098 20.815 22.5827 21.0451C22.7347 21.2538 22.8154 21.5059 22.8127 21.7641C22.8141 
            21.9576 22.7644 22.148 22.6687 22.3161C22.5623 22.4968 22.4129 22.6483 22.2337 22.7571C22.0095 
            22.8938 21.7641 22.9925 21.5077 23.0491C21.1736 23.1238 20.832 23.159 20.4897 23.1541C19.818 
            23.1529 19.1517 23.0344 18.5207 22.8041C17.8615 22.5662 17.2502 22.2123 16.7157 21.7591ZM11.5617 
            14.1211H15.5617V11.5941H4.40869V14.1211H8.39069V25.3751H11.5617V14.1211Z"
            fill="#282B2C"
            fillRule="evenodd"
        />
    </svg>
);
export default TypeScriptIcon;
